// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.steps-to-success {
    margin-top: 50px;
    width: 100%;
}

.steps-to-success .container {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
}

.steps-to-success .step {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 1px solid #a8a8a8;
  background-color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 16px;
  position: relative;
}

.steps-to-success .container .step .label {
    position: absolute;
    bottom: 140%;
    min-width: 95px;

    font-weight: 500;
    font-size: 16px;
    line-height: 21px;
    text-align: center;
}

.steps-to-success .container .step .label.payment-step {
    color: var(--orange);
}

.steps-to-success .container .step .label.download-step {
    font-weight: 600;
}

.steps-to-success .container .step .label.login-step {
    color: var(--gray);
}

.steps-to-success .step.completed {
  border: 1px solid var(--orange);
  background-color: var(--orange);
}

/*.steps-to-success .step.completed:before {*/
/*  content: 'Payment';*/
/*  position: absolute;*/
/*  color: var(--orange);*/
/*  font-weight: 500;*/
/*  font-size: 16px;*/
/*  line-height: 21px;*/
/*  text-align: center;*/
/*  top: -30px;*/
/*}*/

.steps-to-success .step.current {
  border: 1px solid var(--orange);
  background-color: #ffffff;
}

/*.steps-to-success .step.current:before {*/
/*  content: 'Download the app';*/
/*  font-weight: 600;*/
/*  font-size: 16px;*/
/*  line-height: 21px;*/
/*  text-align: center;*/
/*  position: absolute;*/
/*  top: -50px;*/
/*}*/

/*.steps-to-success .step.last:before {*/
/*  content: 'Login';*/
/*  color: var(--gray);*/
/*  font-weight: 500;*/
/*  font-size: 16px;*/
/*  line-height: 21px;*/
/*  text-align: center;*/
/*  position: absolute;*/
/*  top: -30px;*/
/*}*/

.steps-to-success .line {
  height: 2px;
  background: #a8a8a8;
  width: 100%;
}

.steps-to-success .line.red {
  background: var(--orange);
}

.steps-to-success .dot {
  background-color: var(--orange);
  width: 6px;
  height: 6px;
  border-radius: 50%;
}
`, "",{"version":3,"sources":["webpack://./src/orgfit/pilates-3-ltp/css/components/components.success-header.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,kBAAkB;AACpB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,eAAe;;IAEf,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;EACE,+BAA+B;EAC/B,+BAA+B;AACjC;;AAEA,6CAA6C;AAC7C,wBAAwB;AACxB,wBAAwB;AACxB,0BAA0B;AAC1B,sBAAsB;AACtB,qBAAqB;AACrB,uBAAuB;AACvB,wBAAwB;AACxB,gBAAgB;AAChB,IAAI;;AAEJ;EACE,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA,2CAA2C;AAC3C,iCAAiC;AACjC,sBAAsB;AACtB,qBAAqB;AACrB,uBAAuB;AACvB,wBAAwB;AACxB,wBAAwB;AACxB,gBAAgB;AAChB,IAAI;;AAEJ,wCAAwC;AACxC,sBAAsB;AACtB,wBAAwB;AACxB,sBAAsB;AACtB,qBAAqB;AACrB,uBAAuB;AACvB,wBAAwB;AACxB,wBAAwB;AACxB,gBAAgB;AAChB,IAAI;;AAEJ;EACE,WAAW;EACX,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB","sourcesContent":[".steps-to-success {\n    margin-top: 50px;\n    width: 100%;\n}\n\n.steps-to-success .container {\n  display: flex;\n  flex-flow: row nowrap;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 20px;\n}\n\n.steps-to-success .step {\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  border: 1px solid #a8a8a8;\n  background-color: #ffffff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 16px;\n  position: relative;\n}\n\n.steps-to-success .container .step .label {\n    position: absolute;\n    bottom: 140%;\n    min-width: 95px;\n\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 21px;\n    text-align: center;\n}\n\n.steps-to-success .container .step .label.payment-step {\n    color: var(--orange);\n}\n\n.steps-to-success .container .step .label.download-step {\n    font-weight: 600;\n}\n\n.steps-to-success .container .step .label.login-step {\n    color: var(--gray);\n}\n\n.steps-to-success .step.completed {\n  border: 1px solid var(--orange);\n  background-color: var(--orange);\n}\n\n/*.steps-to-success .step.completed:before {*/\n/*  content: 'Payment';*/\n/*  position: absolute;*/\n/*  color: var(--orange);*/\n/*  font-weight: 500;*/\n/*  font-size: 16px;*/\n/*  line-height: 21px;*/\n/*  text-align: center;*/\n/*  top: -30px;*/\n/*}*/\n\n.steps-to-success .step.current {\n  border: 1px solid var(--orange);\n  background-color: #ffffff;\n}\n\n/*.steps-to-success .step.current:before {*/\n/*  content: 'Download the app';*/\n/*  font-weight: 600;*/\n/*  font-size: 16px;*/\n/*  line-height: 21px;*/\n/*  text-align: center;*/\n/*  position: absolute;*/\n/*  top: -50px;*/\n/*}*/\n\n/*.steps-to-success .step.last:before {*/\n/*  content: 'Login';*/\n/*  color: var(--gray);*/\n/*  font-weight: 500;*/\n/*  font-size: 16px;*/\n/*  line-height: 21px;*/\n/*  text-align: center;*/\n/*  position: absolute;*/\n/*  top: -30px;*/\n/*}*/\n\n.steps-to-success .line {\n  height: 2px;\n  background: #a8a8a8;\n  width: 100%;\n}\n\n.steps-to-success .line.red {\n  background: var(--orange);\n}\n\n.steps-to-success .dot {\n  background-color: var(--orange);\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
